<template>
    <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
      <v-data-table
        :headers="headers"
        :items="clientes"
        item-key="name"
        class="elevation-1"
        :search="search"
        :loading="loading"
      >

        <!-- <template v-slot:top>
          <v-row
            class="pa-4"
          >
          <v-col>
              <v-btn
                color="primary"
                :loading="isLoadingDownload"
              @click="exportarExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
              </v-btn>
          </v-col>
            <v-col
              class="py-0 my-0"
            >
              <v-text-field
                v-model="search"
                label="Buscar en entidad tecnica..."
                outlined
              />
            </v-col>
            
          </v-row>
          
        </template>

        <template v-slot:[`item.direccion_fiscal`]="{ item }">
          {{ item.direccion_fiscal!==undefined ? item.direccion_fiscal.substring(0,20) : '' }}
          {{
            (item.direccion_fiscal !== undefined)? ( item.direccion_fiscal.length > 20 ? "..." : "" ) : "" 
          }}
          <v-icon 
            v-if="item.verificado_direccion_fiscal_gps !== '0'"
            color="success"
          >
            mdi-eye-check-outline
          </v-icon>
        </template>

        <template v-slot:[`item.direccion_real`]="{ item }">
          {{ item.direccion_real!==undefined ? item.direccion_real.substring(0,20) : '' }}
          {{
            (item.direccion_real !== undefined)? ( item.direccion_real.length > 20 ? "..." : "" ) : "" 
          }}
          <v-icon 
            v-if="item.verificado_direccion_real_gps !== '0'"
            color="success"
          >
            mdi-eye-check-outline
          </v-icon>
        </template> -->

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarCliente(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 ml-2"
                v-bind="attrs"
                @click="agregarContactosDeEntidadTecnica(item)"
                v-on="on"
              >
                mdi-card-account-phone
              </v-icon>
            </template>
            <span>Contactos</span>
          </v-tooltip> -->
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="verificarDireccion(item)"
              >
                  mdi-clipboard-text-outline
              </v-icon>
            </template>
            <span>Prospección</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="comentariosCliente(item)"
              >
                mdi-comment-quote
              </v-icon>
            </template>
            <span>Comentarios</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-container>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          right
          absolute
          dark
          fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          link
          @click="newOperario"
        >
          <v-list-item-title>Agregar individual</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          v-if="isAdmin"
          link
          @click="uploadExcel"
        >
          <v-list-item-title>Agregar por Excel</v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-menu>

<!-- 
    <view-map-component
      ref="viewMap"
      @onDialog="onDialog"
    />

    <wait-gps-component
    :dialog-wait-gps="dialogWaitGps"
    >
    </wait-gps-component>

    <comentarios
      ref="comentarios"
      @onComentario="onComentario"
    /> -->

    <comentarios
      ref="comentarios"
      @onComentario="onComentario"
    />
    <new-operario
      ref="newOperario"
      @onCreateCliente="onCreateCliente"
    />
    <dialog-personalizado
      ref="dialogDeleteCliente"
      @onDialog="onDialog"
    />

    <!-- <agregar-por-excel
      ref="uploadExcel"
      @onUploadExcel="onUploadExcel"
    />
     -->
  </div>
</template>

<script>
  import NewOperario from './components/NewOperarioComponent.vue'
  import Comentarios from './components/ClienteActualesComentario.vue'
  import DialogPersonalizado from '../components/Dialog.vue'
  // import AgregarPorExcel from './components/AgregarPorExcel.vue'

export default {
  components: {
    NewOperario,
    DialogPersonalizado,
    Comentarios,
    // AgregarPorExcel
  },
  data () {
    return {
      loading: true,
      clientes: [],
      search: '',
      headers: [
        { text: 'RUC', value: 'ruc' },
        { text: 'Razon social', value: 'razon_social' },
        { text: 'tipo_de_tienda', value: 'tipo_de_tienda' },
        { text: 'perfil_de_cliente', value: 'perfil_de_cliente' },
        { text: 'Tipo de cliente', value: 'tipo_de_cliente' },
        { text: 'Canales de venta', value: 'canales_de_venta' },
        { text: 'productos', value: 'productos' },
        { text: 'tiene_material', value: 'tiene_material' },
        { text: 'n_tienda', value: 'n_tienda' },
        // { text: 'n_tienda', value: 'n_tienda' },
        // { text: 'n_tienda', value: 'n_tienda' },
        // { text: 'n_tienda', value: 'n_tienda' },
        // { text: 'n_tienda', value: 'n_tienda' },
        { text: 'departamento', value: 'departamento' },
        { text: 'Provincia', value: 'provincia' },
        { text: 'Accions', value: 'accions' },
      ],
    }
  },
  computed: {
    isAdmin () {
      return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
    },
  },
  
  mounted () {
    this.getClientes()
  },

  methods: {
    
    async getClientes () { //{{url}}/api/distribuidores/prospectar
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar', {
                                    method: 'GET',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                                email_user: JSON.parse(localStorage.userAuth).email
                                              }
                                  })
        const data = await response.json()
        if (data.success) {
          this.clientes = data.data
          this.loading = false
        } else {
          this.loading = false
        }
    },
    newOperario () {
      this.$refs.newOperario.open(undefined)
    },
    onCreateCliente () {
      this.getClientes()
    },
    editarCliente (item) {
      this.$refs.newOperario.open(item)
    },
    comentariosCliente (item) {
        this.$refs.comentarios.open(item)
    },
    onComentario () {
        this.getClientes()
    },
    dialogDelete (item) {
        this.$refs.dialogDeleteCliente.open('Eliminar cliente', '¿Esta seguro de eliminar cliente?', item)
    },
    onDialog (cliente) {
      this.eliminarEntidadTecnica(cliente)
    },
    async eliminarEntidadTecnica (cliente) {
      const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/' + cliente.id, {
                                  method: 'DELETE',
                                  headers: {
                                              'Content-type': 'application/json;charset=UTF-8',
                                            }
                                })
      const data = await response.json()
      if (data.success) {
        this.getClientes()
      } else {
        this.getClientes()
      }
      this.$refs.dialogDeleteCliente.close()
    },
    uploadExcel () {
        this.$refs.uploadExcel.open()
    },
    onUploadExcel () {
        this.getClientes()
    }

  },
}
</script>

<style>
</style>
